import { EntityTypeEnum } from "@scrinz/dtos";
export function isGroup(entity) {
    return entity.type === EntityTypeEnum.Group;
}
//# sourceMappingURL=is-group.js.map